import { useProductPageStore } from './ProductPageStore'

import { useCallback, useContext, useEffect, useState } from 'react'

import { useNavigationStore } from 'Stores/NavigationStore'

import { getSessionStoragePageViewCount } from 'Clutch/Utilities/EngagedSessionStorageUtility/EngagedSessionStorageUtility'

import useRecentHistory from 'Clutch/Hooks/useRecentHistory'

export default function ProductPageWiring({ set }) {
  const cachedTime = useProductPageStore((x) => x.cachedTime)
  const edgeCacheDate = useProductPageStore((x) => x.edgeCacheDate)
  const skuBaseNumber = useProductPageStore((x) => x.skuBaseNumber)
  const productPageUrl = useProductPageStore((x) => x.productPageUrl)
  const segmentCategorization = useProductPageStore((x) => x.segmentCategorization)
  const title = useProductPageStore((x) => x.title)

  const needToCalculateQuantityBreak = useProductPageStore((x) => x.needToCalculateQuantityBreak)
  const quantityRequested = useProductPageStore((x) => x.quantityRequested)
  const updatePriceWithPriceBreak = useProductPageStore((x) => x.updatePriceWithPriceBreak)
  const aPlusContentScrollToLock = useProductPageStore((x) => x.aPlusContentScrollToLock)
  const readyForScrollData = useProductPageStore((x) => x.readyForScrollData)
  const isDetailsAccordionOpen = useProductPageStore((x) => x.isDetailsAccordionOpen)

  const [scrollStopped, setScrollStopped] = useState(false)

  const ScrollEnd = useCallback(() => {
    let scrollTimeout

    clearTimeout(scrollTimeout)
    setTimeout(function () {
      setScrollStopped(true)
      window.removeEventListener('scroll', ScrollEnd)
    }, 1000)
  }, [])

  useEffect(() => {
    // log out the time when the page was cached in vercel
    console.log('product service cached time: ', cachedTime)
    console.log('vercel html cached time: ', edgeCacheDate)

    try {
      const pageViewCount = getSessionStoragePageViewCount()
      const existingProductList = useRecentHistory.GetMostRecentProductListName()
      const isFirstPageView = pageViewCount <= 1
      const noExistingProductList = existingProductList === 'not_set'
      const hasLandingAttribution = existingProductList?.startsWith('Landing')

      if (isFirstPageView && noExistingProductList && title) {
        //useRecentHistory.SetMostRecentProductList('landing', title)
      } else if (!isFirstPageView && hasLandingAttribution) {
        useRecentHistory.ClearMostRecentProductList()
      }
    } catch (err) {
      console.error('Error setting landing attribution', err)
    }

    useRecentHistory.AddToRecentHistory({
      skuBaseNumber: skuBaseNumber,
      productPageUrl: productPageUrl,
      segmentCategorization: segmentCategorization,
      title: title,
    })
  }, [])

  useEffect(() => {
    if (skuBaseNumber) {
      useRecentHistory.AddToRecentHistory({
        skuBaseNumber: skuBaseNumber,
        productPageUrl: productPageUrl,
        segmentCategorization: segmentCategorization,
        title: title,
      })
    }
  }, [skuBaseNumber])

  useEffect(() => {
    if (needToCalculateQuantityBreak) {
      updatePriceWithPriceBreak(quantityRequested)
    }
  }, [needToCalculateQuantityBreak])

  useEffect(() => {
    if (scrollStopped) {
      set((state) => {
        const { shouldOpenAccordion, ...rest } = state
        return {
          ...rest,
          [`is${state.aPlusContentScrollToLock.accordionName}AccordionOpen`]: shouldOpenAccordion,
          aPlusContentScrollToLock: { active: false },
        }
      })
    }
  }, [scrollStopped])

  useEffect(() => {
    if (
      aPlusContentScrollToLock?.active &&
      (!aPlusContentScrollToLock.waitForAccordionOpen || readyForScrollData[aPlusContentScrollToLock.accordionName])
    ) {
      document.getElementById(aPlusContentScrollToLock.id).scrollIntoView({ behavior: 'smooth' })
      setScrollStopped(false)
      window.addEventListener('scroll', ScrollEnd)
    }
  }, [aPlusContentScrollToLock, readyForScrollData, isDetailsAccordionOpen])
}
